module.exports = __webpack_public_path__ + "img/1.b5b6d934.jpg";